var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnDestroy, OnInit } from '@angular/core';
import { GeneralService } from '../../../../_services/general.service';
import { InspectorsService } from '../../../../_services/inspectors.service';
import { ApiService } from '../../../../_interceptors/api.service';
var InspectorsInspectionsListComponent = /** @class */ (function () {
    function InspectorsInspectionsListComponent(inspectorsService, apiService, generalService) {
        this.inspectorsService = inspectorsService;
        this.apiService = apiService;
        this.generalService = generalService;
        this.routerTransition = true;
        this.totalItems = 0;
        this.currentPage = 0;
        this.searchString = '';
        this.isLoading = false;
        // noinspection JSMismatchedCollectionQueryUpdate
        this.inspectorsInspections = [];
    }
    InspectorsInspectionsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiService.connectionChanged.subscribe(function (online) {
            if (online && _this.inspectorsInspections.length === 0) {
                _this.currentPage = 0;
                _this.getInspectorsInspections();
            }
        });
        this.getInspectorsInspections();
    };
    InspectorsInspectionsListComponent.prototype.ngOnDestroy = function () {
    };
    InspectorsInspectionsListComponent.prototype.getInspectorsInspections = function (append_data) {
        var _this = this;
        if (append_data === void 0) { append_data = true; }
        if (!this.isLoading) {
            this.isLoading = true;
            this.currentPage++;
            this.inspectorsService.getInspectorsInspections({
                start: (this.currentPage - 1) * this.generalService.itemsPerPage,
                length: this.generalService.itemsPerPage,
                'columns[0][search][value]': this.searchString
            }).then(function (data) {
                var _a;
                if (typeof data !== 'undefined') {
                    if (typeof data.recordsTotal !== 'undefined') {
                        _this.totalItems = data.recordsTotal;
                    }
                    if (append_data === true) {
                        (_a = _this.inspectorsInspections).push.apply(_a, __spread(data.data));
                    }
                    else {
                        _this.inspectorsInspections = data.data;
                    }
                }
                _this.isLoading = false;
            });
        }
    };
    InspectorsInspectionsListComponent.prototype.search = function ($event) {
        this.searchString = $event;
        this.currentPage = 0;
        this.getInspectorsInspections(false);
    };
    return InspectorsInspectionsListComponent;
}());
export { InspectorsInspectionsListComponent };
